import React, { Fragment } from 'react';
const bonuses = [{
  image: 'https://res.cloudinary.com/dd0wtuekk/image/upload/v1771289018/hf_20260216_122921_d804775d-fcd6-4acc-b832-f1a3c6f473a1_fac79q.png',
  title: '🎁Cómo hablarle después de un mal partido',
  points: ['Qué decir exactamente', 'Qué evitar', 'Refuerzo mental en 10 min']
}, {
  image: 'https://res.cloudinary.com/dd0wtuekk/image/upload/v1771289018/hf_20260216_123118_2eeb8437-0b52-4cb5-b9ee-1d5f540034dc_eity8x.png',
  title: '🎁Plan de disciplina en casa',
  points: ['Rutina entrenamiento', 'Rutina partido', 'Micro-hábitos diarios']
}, {
  image: 'https://res.cloudinary.com/dd0wtuekk/image/upload/v1771289019/hf_20260216_123453_7fe310d1-ce15-47b9-8dec-9daeec8e13f4_rykwxg.png',
  title: '🎁Diario de Mentalidad Competitiva',
  points: ['Registre objetivos', 'Aprenda de errores', 'Refuerce progreso']
}, {
  image: 'https://res.cloudinary.com/dd0wtuekk/image/upload/v1771289017/hf_20260216_123936_2084340b-f6e5-48fb-a8ae-e20e0cff1725_kbfjgf.png',
  title: '🎁Protocolo Confianza Inquebrantable',
  points: ['Partido importante', 'Nervios', 'Paso a paso claro']
}, {
  image: 'https://res.cloudinary.com/dd0wtuekk/image/upload/v1771289017/hf_20260216_124151_8c669966-6a97-4440-a1fa-a870926ed0e6_okik9v.png',
  title: '🎁Cómo desarrollar liderazgo en el equipo',
  points: ['Actitud', 'Presencia', 'Mentalidad']
}];
export function CincoRegalosSection() {
  return <section className="w-full text-center" style={{
    padding: '40px 16px',
    background: '#f5f5f5'
  }} data-id="element-30">
      {/* Título */}
      <div style={{
      fontSize: '18px',
      fontWeight: 700,
      color: '#111'
    }} data-id="element-31">
        🎁 Además, si compras HOY te llevas 5 REGALOS EXCLUSIVOS
      </div>

      <p style={{
      marginTop: '14px',
      fontSize: '14px',
      color: '#4b5563'
    }} data-id="element-32">
        Te llevas cinco bonos estratégicos diseñados para fortalecer la
        confianza de tu hijo y potenciar su rendimiento dentro del campo.
      </p>

      {/* Grid Bonos */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '12px',
      marginTop: '25px'
    }} data-id="element-33">
        {bonuses.map((bonus, index) => <div key={index} style={{
        background: '#ffffff',
        borderRadius: '14px',
        padding: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        textAlign: 'left',
        ...(index === 4 ? {
          gridColumn: '1 / -1'
        } : {})
      }} data-id="element-34">
            <img src={bonus.image} alt={bonus.title} style={{
          width: '100%',
          borderRadius: '10px',
          marginBottom: '8px'
        }} data-id="element-35" />
            <div style={{
          fontSize: '13px',
          fontWeight: 700
        }} data-id="element-36">
              {bonus.title}
            </div>
            <div style={{
          fontSize: '12px',
          color: '#6b7280',
          margin: '6px 0'
        }} data-id="element-37">
              {bonus.points.map((point, i) => <Fragment key={i} data-id="element-38">
                  ✔ {point}
                  {i < bonus.points.length - 1 && <br data-id="element-39" />}
                </Fragment>)}
            </div>
          </div>)}
      </div>

      {/* Tarjeta Valor */}
      <div style={{
      marginTop: '25px',
      background: '#ffffff',
      padding: '22px',
      borderRadius: '16px',
      boxShadow: '0 6px 18px rgba(0,0,0,0.08)'
    }} data-id="element-40">
        <div style={{
        fontSize: '16px',
        fontWeight: 700
      }} data-id="element-41">
          ¡Valor total de los 5 regalos!
        </div>

        <div style={{
        marginTop: '10px',
        fontSize: '14px',
        color: '#6b7280'
      }} data-id="element-42">
          Valor total 5 regalos:
        </div>

        <div style={{
        color: '#dc2626',
        textDecoration: 'line-through',
        fontWeight: 800,
        marginTop: '4px'
      }} className="text-[28px]" data-id="element-43">
          125€
        </div>

        <div style={{
        marginTop: '10px',
        fontSize: '14px',
        color: '#6b7280'
      }} data-id="element-44">
          Solo por <strong data-id="element-45">HOY:</strong>
        </div>

        <div style={{
        color: '#16a34a',
        fontWeight: 900,
        marginTop: '4px'
      }} className="text-[40px]" data-id="element-46">
          GRATIS
        </div>
      </div>
    </section>;
}